/**
 * R-248 — map the escalate endpoint's `TransitionResult.action` to a keyer-facing
 * toast outcome for the "Wrong document type" on-ramp.
 *
 * The escalate route returns `action: "escalated"` when the document reaches the
 * Escalation Queue, but `action: "held"` when the job type has no `escalation`
 * pipeline step (`escalateDocument`'s documented hold-fallback). In the held case
 * the doc is NOT sent to a supervisor, so the keyer must be told the truth instead
 * of a false "sent to supervisor" success. Surfaced live on preprod 2026-06-04.
 */
export function escalateFlagOutcome(action: string | undefined): { ok: boolean; message: string } {
  if (action === "escalated") {
    return { ok: true, message: "Flagged as wrong type — sent to supervisor" };
  }
  return {
    ok: false,
    message:
      "Not escalated — this job type has no escalation step, so the document was held. Ask an admin to configure one.",
  };
}
